import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material';
import { DataService } from 'src/app/services/data.service';
import { AddMajorComponent } from '../add-major/add-major.component';
import { AuthService } from 'src/app/auth/auth.service';
import { List } from 'src/app/stores/administrator/list.store';
import { Term } from 'src/app/stores/administrator/term.store';

@Component({
  selector: 'app-major',
  templateUrl: './major.component.html',
  styleUrls: ['./major.component.scss']
})
export class MajorComponent implements OnInit {
  SELECTED_FACULTY: any = null;

  constructor(
    private auth: AuthService,
    private route: ActivatedRoute,
    public store: Term,
    private ds: DataService,
    public dialog: MatDialog) { }

  create() {
    const dialogRef = this.dialog.open(AddMajorComponent, {
      data: this.SELECTED_FACULTY,
      panelClass: 'register-test-overlay-panel',
      width: '30vw',
      height: '100vh',
      disableClose: false,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => { });
  }

  async ngOnInit() {
    await this.auth.fetchEnvironment()
    this.route.parent.params.subscribe(async params => {
      const { id } = params;
      this.SELECTED_FACULTY = id;
      this.store.fetchData(this.ds.majorRef(ref => ref.where('facultyKey', "==", id).orderBy('name')))
    })
  }

  ngOnDestroy() {
    this.store.dispost();
  }
}
